export const STATUS_META = {
  a_valider: { label: "À traiter", cls: "bg-[#FFBA08]/20 text-[#B07d00]" },
  a_payer: { label: "En attente de paiement", cls: "bg-[#0077B6]/15 text-[#0077B6]" },
  preparation: { label: "En préparation", cls: "bg-[#E4A11B]/20 text-[#B07d00]" },
  en_livraison: { label: "En livraison", cls: "bg-[#E85D04]/15 text-[#E85D04]" },
  remis_transporteur: { label: "Remis au transporteur", cls: "bg-[#0077B6]/15 text-[#0077B6]" },
  livre: { label: "Livré", cls: "bg-[#2D6A4F]/15 text-[#2D6A4F]" },
  en_attente_retrait: { label: "En attente de retrait", cls: "bg-[#7048E8]/15 text-[#7048E8]" },
  echec_livraison: { label: "Échec livraison", cls: "bg-[#D00000]/15 text-[#D00000]" },
  annule: { label: "Annulé", cls: "bg-[#D00000]/15 text-[#D00000]" },
  refuse: { label: "Refusée", cls: "bg-[#D00000]/15 text-[#D00000]" },
};

const CUR = {
  XOF: { symbol: "FCFA", before: false, dec: 0 },
  XAF: { symbol: "FCFA", before: false, dec: 0 },
  GNF: { symbol: "FG", before: false, dec: 0 },
  CDF: { symbol: "FC", before: false, dec: 0 },
  MGA: { symbol: "Ar", before: false, dec: 0 },
  MRU: { symbol: "UM", before: false, dec: 2 },
  CAD: { symbol: "$", before: true, dec: 2 },
  EUR: { symbol: "€", before: false, dec: 2 },
};

export const CURRENCIES = ["XOF", "XAF", "GNF", "CDF", "MGA", "MRU", "CAD", "EUR"];

export const money = (amount, currency = "XOF") => {
  const c = CUR[currency] || CUR.XOF;
  const n = Number(amount) || 0;
  const s = c.dec
    ? n.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : Math.round(n).toLocaleString("fr-FR");
  return c.before ? `${c.symbol}${s}` : `${s} ${c.symbol}`;
};

// Backward-compatible default (FCFA)
export const fcfa = (n) => money(n, "XOF");

export const DELIVERY_COLOR = {
  green: { dot: "bg-[#2D6A4F]", label: "Dans les temps" },
  orange: { dot: "bg-[#E4A11B]", label: "À surveiller" },
  red: { dot: "bg-[#D00000]", label: "En retard" },
};

// Catalogue des moyens de paiement (préréglages) avec couleur de marque
export const PAY_PRESETS = {
  wave: { label: "Wave", color: "#1DA1F2" },
  orange: { label: "Orange Money", color: "#FF7900" },
  mtn: { label: "MTN MoMo", color: "#FFCB05" },
  moov: { label: "Moov Money", color: "#004C97" },
  free: { label: "Free Money", color: "#CD1C18" },
  wizall: { label: "Wizall Money", color: "#00A859" },
  tmoney: { label: "T-Money", color: "#E2001A" },
  flooz: { label: "Flooz", color: "#662D91" },
  airtel: { label: "Airtel Money", color: "#ED1C24" },
  mpesa: { label: "M-Pesa", color: "#10A36E" },
  bankily: { label: "Bankily", color: "#F39200" },
  mvola: { label: "MVola", color: "#FFCB05" },
  interac: { label: "Virement Interac", color: "#E8A317" },
  paypal: { label: "PayPal", color: "#003087" },
  carte: { label: "Carte bancaire (Stripe)", color: "#635BFF" },
  virement: { label: "Virement bancaire (RIB)", color: "#1B4332" },
  lydia: { label: "Lydia / Paylib", color: "#0A7CFF" },
  especes: { label: "Espèces", color: "#2D6A4F" },
  mobile_money: { label: "Mobile Money", color: "#E85D04" },
};

// Pays supportés (Afrique de l'Ouest/Centrale francophone + Canada + France)
// tax = taux de TVA par défaut en % (null = taxes automatiques multi-lignes, ex. Canada)
export const COUNTRIES = {
  CI: { name: "Côte d'Ivoire", flag: "🇨🇮", currency: "XOF", tax: 18, presets: ["wave", "orange", "mtn", "moov"] },
  SN: { name: "Sénégal", flag: "🇸🇳", currency: "XOF", tax: 18, presets: ["wave", "orange", "free", "wizall"] },
  ML: { name: "Mali", flag: "🇲🇱", currency: "XOF", tax: 18, presets: ["orange", "moov", "wave"] },
  BF: { name: "Burkina Faso", flag: "🇧🇫", currency: "XOF", tax: 18, presets: ["orange", "moov", "wave"] },
  BJ: { name: "Bénin", flag: "🇧🇯", currency: "XOF", tax: 18, presets: ["mtn", "moov", "wave"] },
  TG: { name: "Togo", flag: "🇹🇬", currency: "XOF", tax: 18, presets: ["tmoney", "flooz", "wave"] },
  NE: { name: "Niger", flag: "🇳🇪", currency: "XOF", tax: 19, presets: ["airtel", "moov", "mtn"] },
  GW: { name: "Guinée-Bissau", flag: "🇬🇼", currency: "XOF", tax: 17, presets: ["orange", "mtn"] },
  CM: { name: "Cameroun", flag: "🇨🇲", currency: "XAF", tax: 19.25, presets: ["mtn", "orange"] },
  GA: { name: "Gabon", flag: "🇬🇦", currency: "XAF", tax: 18, presets: ["airtel", "moov"] },
  CG: { name: "Congo", flag: "🇨🇬", currency: "XAF", tax: 18.9, presets: ["mtn", "airtel"] },
  TD: { name: "Tchad", flag: "🇹🇩", currency: "XAF", tax: 18, presets: ["airtel", "moov"] },
  CF: { name: "Centrafrique", flag: "🇨🇫", currency: "XAF", tax: 19, presets: ["orange", "mtn"] },
  GN: { name: "Guinée", flag: "🇬🇳", currency: "GNF", tax: 18, presets: ["orange", "mtn"] },
  CD: { name: "RD Congo", flag: "🇨🇩", currency: "CDF", tax: 16, presets: ["mpesa", "orange", "airtel"] },
  MR: { name: "Mauritanie", flag: "🇲🇷", currency: "MRU", tax: 16, presets: ["bankily"] },
  MG: { name: "Madagascar", flag: "🇲🇬", currency: "MGA", tax: 20, presets: ["mvola", "orange", "airtel"] },
  CA: { name: "Canada", flag: "🇨🇦", currency: "CAD", tax: null, presets: ["interac", "paypal", "carte", "especes"] },
  FR: { name: "France", flag: "🇫🇷", currency: "EUR", tax: 20, presets: ["virement", "paypal", "carte", "lydia", "especes"] },
};

// Predefined 2-hour delivery / pickup time slots
export const TIME_SLOTS = ["08h-10h", "10h-12h", "12h-14h", "14h-16h", "16h-18h", "18h-20h"];

// Catalogue des tailles de vêtements (5 tailles). Affichage « S (Small) ». cm = tour de poitrine indicatif (réf. Afrique de l'Ouest).
export const SIZES = [
  { code: "S", en: "Small", cm: "84 – 88 cm" },
  { code: "M", en: "Medium", cm: "90 – 94 cm" },
  { code: "L", en: "Large", cm: "98 – 104 cm" },
  { code: "XL", en: "Extra Large", cm: "106 – 112 cm" },
  { code: "XXL", en: "Double Extra Large", cm: "114 – 122 cm" },
];
export const SIZE_BY_CODE = Object.fromEntries(SIZES.map((s) => [s.code, s]));

// Catégories officielles SuccèsNet (le vendeur choisit lors de l'ajout d'un produit)
export const PRODUCT_CATEGORIES = [
  { key: "mode", label: "Mode & Accessoires" },
  { key: "bien_etre", label: "Santé & Bien-être" },
  { key: "pharmacie", label: "Santé & Pharmacie" },
  { key: "electronique", label: "Électronique & High-Tech" },
  { key: "maison", label: "Maison & Décoration" },
  { key: "alimentation", label: "Alimentation & Épicerie" },
  { key: "sports", label: "Sports & Loisirs" },
  { key: "enfants", label: "Enfants & Jouets" },
];

// Champs spécifiques par catégorie (la fiche produit s'adapte). sizes=true => sélecteur de tailles vêtements.
export const CATEGORY_FIELDS = {
  "Mode & Accessoires": { sizes: true, fields: [
    { key: "couleur", label: "Couleur", type: "text" },
    { key: "matiere", label: "Matière", type: "text" },
  ] },
  "Santé & Bien-être": { sizes: false, fields: [
    { key: "type", label: "Type (peau / cheveux / corps)", type: "text" },
    { key: "contenance", label: "Contenance (ml / g)", type: "text" },
    { key: "marque", label: "Marque", type: "text" },
    { key: "peremption", label: "Date de péremption", type: "date" },
  ] },
  "Santé & Pharmacie": { sizes: false, fields: [
    { key: "forme", label: "Forme", type: "select", options: ["Comprimé", "Sirop", "Crème", "Gélule", "Autre"] },
    { key: "dosage", label: "Dosage", type: "text" },
    { key: "contenance", label: "Contenance", type: "text" },
    { key: "peremption", label: "Date de péremption", type: "date" },
    { key: "ordonnance", label: "Ordonnance requise", type: "select", options: ["Non", "Oui"] },
  ] },
  "Électronique & High-Tech": { sizes: false, fields: [
    { key: "marque", label: "Marque", type: "text" },
    { key: "modele", label: "Modèle", type: "text" },
    { key: "etat", label: "État", type: "select", options: ["Neuf", "Occasion", "Reconditionné"] },
    { key: "garantie", label: "Garantie", type: "text" },
    { key: "couleur", label: "Couleur", type: "text" },
    { key: "capacite", label: "Capacité / Stockage", type: "text" },
  ] },
  "Maison & Décoration": { sizes: false, fields: [
    { key: "matiere", label: "Matière", type: "text" },
    { key: "dimensions", label: "Dimensions", type: "text" },
    { key: "couleur", label: "Couleur", type: "text" },
  ] },
  "Alimentation & Épicerie": { sizes: false, fields: [
    { key: "poids", label: "Poids / Contenance", type: "text" },
    { key: "marque", label: "Marque", type: "text" },
    { key: "peremption", label: "Date de péremption", type: "date" },
  ] },
  "Sports & Loisirs": { sizes: false, fields: [
    { key: "marque", label: "Marque", type: "text" },
    { key: "couleur", label: "Couleur", type: "text" },
    { key: "taille", label: "Taille / Pointure (optionnel)", type: "text" },
  ] },
  "Enfants & Jouets": { sizes: false, fields: [
    { key: "age", label: "Âge recommandé", type: "text" },
    { key: "marque", label: "Marque", type: "text" },
    { key: "couleur", label: "Couleur", type: "text" },
  ] },
};export const sizeLabel = (code) => {
  const s = SIZE_BY_CODE[code];
  return s ? `${s.code} (${s.en})` : code;
};

export const PAYMENT_TYPE_LABELS = {
  online: "Paiement en ligne",
  on_delivery: "Paiement à la réception",
  on_pickup: "Retrait en boutique — paiement sur place",
  interac_etransfer: "Interac e-Transfer",
};

// Next 14 days as {value: 'YYYY-MM-DD', label: 'lun. 24/06'}
export const nextDays = (count = 14) => {
  const out = [];
  const today = new Date();
  for (let i = 0; i < count; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    const value = d.toISOString().slice(0, 10);
    const label = d.toLocaleDateString("fr-FR", { weekday: "short", day: "2-digit", month: "2-digit" });
    out.push({ value, label: i === 0 ? `Aujourd'hui ${d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit" })}` : i === 1 ? `Demain ${d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit" })}` : label });
  }
  return out;
};
